<template>
  <div id="term-page">
    <div class="title-container">
      <div class="t-title">
        <p>{{ $t('terms.title_terms') }}</p>
        <img src="@/assets/images/about/bgr-policy.svg" />
      </div>
    </div>
   
    <div class="content-terms">
      <p class="text-sub text-effective">
        <strong>{{ $t('terms.new.effective_date') }}</strong> {{ $t('terms.new.effective_date_val') }}<br>
        <strong>{{ $t('terms.new.entity_label') }}</strong> {{ $t('terms.new.entity_val') }}
      </p>

      <div class="para-term">
        <div class="t-bold-term">{{ $t('terms.new.intro_title') }}</div>
        <p class="text-sub">{{ $t('terms.new.intro_p1') }}</p>
        <p class="text-sub">{{ $t('terms.new.intro_p2') }}</p>
        <p class="text-sub">{{ $t('terms.new.intro_p3') }}</p>
        <p class="text-sub">{{ $t('terms.new.intro_p4') }}</p>
      </div>

      <div class="para-term">
        <div class="t-bold-term">{{ $t('terms.new.eligibility_title') }}</div>
        <p class="text-sub">{{ $t('terms.new.eligibility_intro') }}</p>
        <ul>
          <li>{{ $t('terms.new.eligibility_li1') }}</li>
          <li>{{ $t('terms.new.eligibility_li2') }}</li>
          <li>{{ $t('terms.new.eligibility_li3') }}</li>
          <li>{{ $t('terms.new.eligibility_li4') }}</li>
        </ul>
        <p class="text-sub">{{ $t('terms.new.eligibility_outro') }}</p>
      </div>

      <div class="para-term">
        <div class="t-bold-term">{{ $t('terms.new.services_title') }}</div>
        
        <div class="m-bottom">
          <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_a_title') }}</div>
          <p class="text-sub">{{ $t('terms.new.service_a_desc') }}</p>
          <ul>
            <li>{{ $t('terms.new.service_a_li1') }}</li>
            <li>{{ $t('terms.new.service_a_li2') }}</li>
            <li>{{ $t('terms.new.service_a_li3') }}</li>
          </ul>
        </div>

        <div class="m-bottom">
          <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_b_title') }}</div>
          <p class="text-sub">{{ $t('terms.new.service_b_desc') }}</p>
          <ul>
            <li>{{ $t('terms.new.service_b_li1') }}</li>
            <li>{{ $t('terms.new.service_b_li2') }}</li>
            <li>{{ $t('terms.new.service_b_li3') }}</li>
          </ul>
        </div>

        <div>
          <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_c_title') }}</div>
          <p class="text-sub">{{ $t('terms.new.service_c_desc') }}</p>
          <ul>
            <li>{{ $t('terms.new.service_c_li1') }}</li>
            <li>{{ $t('terms.new.service_c_li2') }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
      urlPolicy: `${window.location.origin}/policy`
    };
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    document.title = this.$t("menu.terms") + ` – ${this.tabTitle}`;
    window.addEventListener('beforeunload', this.scrollToTop);
  },
  
};
</script>
<style lang="scss">
@import "@/assets/sass/variables";
.m-bottom {
  margin-bottom: 8px;
}
.dark-theme {
  #term-page {
    background-color: $color-night;
    .title-container{
      background: $color-black-shark;
      border-top: 4px solid $color-black;
    }
    .content-terms {
      .text-effective {
        color: $color-white !important;
      }
    }
  }
}
#term-page {
  background-color: $color-white;

  .title-container{
    background: $color-eerie-black;

    .t-title{
      margin: 0 auto;
      padding: 0;
      max-width: 1440px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      p {
        color: $color-white;
        font-size: 34px;
        line-height: 40px;
        font-family: $font-inter-bold;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
      }
    }
  }

  .content-terms {
    margin: 0 auto;
    padding: 50px 0px 120px;
    max-width: 1440px;
    font-size: 16px;
    line-height: 19px;  
    .t-bold-term {
      font-size: 16px;
      line-height: 19px;
      color: var(--text-primary-color);
      font-family: $font-inter-bold;
      font-family: $font-inter-bold;
      margin-bottom: 8px;
      &.sub-term-title {
        font-size: 14px;
        color: var(--text-close);
      }
    }
    .text-sub {
      color: var(--text-close);
      margin-top: 8px;
      text-align: justify;
      line-height: 27px;
      &.text-effective {
         color: $color-black;
      }
    }

    .para-term {
      padding: 24px 0 0;

      & ul {
        padding: 8px 0 0px 18px;
        margin: 0;
        list-style: disc;
        
        li {
          color: var(--text-close);
          text-align: justify;
          line-height: 27px;
        }
      } 
      & ol{
        counter-reset: item;
        li {
            display: block;
            margin-left: 1.7em;
            color: var(--text-close);
            text-align: justify;
            line-height: 27px;
            &::before {
                content: counter(item) ". ";
                counter-increment: item;
                position: absolute;
                margin-left: -1.7em;
            }
        }
      }
      .list-sub {
        p{
          margin: 2px 0;
          color: var(--text-close);
          text-align: justify;
          line-height: 27px;
        }
      }
      .list-child {
        padding-left: 0;
       
        margin-top: 5px;
      }
      .list-child-limit {
          padding: 8px 0;
          counter-reset: item;
        
          li {
            display: block;
            margin-left: 1.7em;
            color: var(--text-close);
            &::before {
                content: counter(item) ") ";
                counter-increment: item;
                position: absolute;
                margin-left: -1.7em;
            }
        }
        
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  #term-page {
    .content-terms{
      padding: 40px 16px;
    }
    .title-container {
      padding-left: 19px;
    }
  }
}

  @media screen and (max-width: 992px) {
    #term-page {
      .title-container {
        .t-title {
          max-height: 82px;
          p{
            font-size: 24px;
            line-height: 29px;
          }
          img {
            width: 222px;
          }
        }
      }
      .content-terms {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
</style>

